import React from 'react'
import { Trigger } from '@radix-ui/react-popover'
import { Box, Flex, FlexProps } from 'rebass/styled-components'

import { ChevronIcon } from '../Icon'

export interface DropdownTriggerProps extends Omit<FlexProps, 'label'> {
  label: React.ReactNode
  variant?: 'success' | 'error' | 'warning' | 'disabled'
}

export const DropdownTrigger = ({
  disabled = false,
  label,
  variant,
  sx,
  ...props
}: DropdownTriggerProps): JSX.Element => {
  return (
    <Trigger asChild disabled={disabled}>
      <Flex
        as="button"
        data-name="DropdownTrigger"
        sx={{ ...sx }}
        className={disabled ? 'disabled' : variant}
        {...props}
      >
        <Box as="span" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {label}
        </Box>
        <ChevronIcon color="blue300" strokeWidth={1.5} sx={{ flexShrink: 0 }} />
      </Flex>
    </Trigger>
  )
}
